<!-- @format -->

<template>
  <div style="overflow:hidden;width:100%;" :style="{ height: rowHeight * rowCount + 'px' }">
    <div
      ref="inner"
      style="position:relative;width:100%;left:0;"
      :style="{ top: '-' + rowHeight * (rowCount + 2) + 'px' }"
    >
      <div v-bind:key="index" v-for="(item, index) in showData">
        <a-row :style="{ height: rowHeight + 'px' }">
          <a-col
            :data-each-key="innerItem[eachKey]"
            class="infinite-scroll-item"
            style="height:100%;"
            :span="24 / col"
            :key="innerItem[eachKey]"
            v-for="innerItem in item"
          >
            <slot :rowIndex="index" :colData="innerItem"></slot>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>
<script>
import Timer from 'animation-util';
function formatTime(date, hmdOnly = false) {
  date = date || new Date();
  let t = date.getTime();
  if (typeof t === 'number' && isNaN(t)) {
    return '';
  }

  let d = new Date(date);

  var yyyy = d.getFullYear().toString();
  var mm = (d.getMonth() + 1).toString(); // getMonth() is zero-based
  var dd = d.getDate().toString();
  var hh = d.getHours().toString();
  var ii = d.getMinutes().toString();
  var ss = d.getSeconds().toString();
  // return '20180211'+hh+ii+ss;

  let res = yyyy + '-' + (mm[1] ? mm : '0' + mm[0]) + '-' + (dd[1] ? dd : '0' + dd[0]);
  if (!hmdOnly) {
    res += ' ' + (hh[1] ? hh : '0' + hh[0]) + ':' + (ii[1] ? ii : '0' + ii[0]) + ':' + (ss[1] ? ss : '0' + ss[0]);
  }

  return res;
  // return yyyy+'/' + (mm[1]?mm:"0"+mm[0])+'/' + (dd[1]?dd:"0"+dd[0])+' '+ (hh[1]?hh:"0"+hh[0])+':'+ (ii[1]?ii:"0"+ii[0])+':'+ (ss[1]?ss:"0"+ss[0])

  // return yyyy+'-' + (mm[1]?mm:"0"+mm[0])+'-' + (dd[1]?dd:"0"+dd[0]);
}

setInterval(() => {
  if (
    Math.max(
      formatTime(new Date())
        .split(' ')[1]
        .split(':')
        .join('') - 0,
      30000
    ) < 40000
  ) {
    location.reload();
  }
}, 20 * 60 * 1000);

export default {
  mounted() {
    if (process.env.NODE_ENV == 'development') {
      window[this.debugKey] = this;
    }
    // alert(this.list.length);
  },
  data() {
    return {
      hasInited: false,
      clock: null,
      list: [],
      // rowScrollIndex: 0,
      showData: []
    };
  },
  methods: {
    animRun() {
      var block = this.$refs.inner;
      let innerW = this.$refs.inner.offsetWidth;
      let topWhenLastTime = parseInt(this.$refs.inner.style.top);

      let intervalFun = () => {
        // let useScrollAnim = false;
        // if (this.rowScrollIndex < this.list.length - 1) {
        //   this.rowScrollIndex++;
        //   useScrollAnim = true;
        // }
        let useScrollAnim = parseInt(this.$refs.inner.style.top) != 0;
        // this.getFirstRowDataInShowData()[0][this.eachKey] !=
        // this.showData[0][0][this.eachKey];
        let visiblePortHeight = this.rowHeight * this.rowCount;
        let timer = new Timer({
          duration: this.scrollDuration,
          easing: useScrollAnim ? this.scrollEasing : this.shakeEasing,
          // easing: "easeOutSine",
          onStart: e => {
            useScrollAnim = this.updateShowData();
            // console.log(e);
          },
          onRun: e => {
            if (useScrollAnim) {
              let targetTop;
              if (!this.hasInited) {
                targetTop = this.getFirstAnimTargetTop();
              } else {
                targetTop = 0;
              }
              block.style.top = `${e.percent * (targetTop - topWhenLastTime) + topWhenLastTime}px`;
            } else {
              this.shake(block, e.percent);
            }
          },
          onEnd: e => {
            if (!this.hasInited) {
              // topWhenLastTime = this.getFirstAnimTargetTop();
              this.hasInited = true;
            }

            // setTimeout(() => {
            this.updateShowData();
            // }, 100);
          }
        });
        timer.run();
      };

      setTimeout(intervalFun);
    },
    updateShowData() {
      // if (parseInt(this.$refs.inner.style.top) == 0) {
      // console.log("yesssssssss");
      let id = this.showData[0][0][this.eachKey],
        nextRowArr = [],
        index = this.list.findIndex(item => item[this.eachKey] == id);

      // console.log("index--:", index);
      if (index > 0) {
        new Array(this.col).fill(void 0).forEach((item, idx) => {
          let prevIndex = index - 1 - idx;
          // console.log("prevIndex and v--:", prevIndex, this.list[prevIndex]);
          if (prevIndex > -1) {
            nextRowArr.unshift(this.list[prevIndex]);
          }
        });
      }
      if (parseInt(this.$refs.inner.style.top) != 0) {
        return true;
      } else {
        if (nextRowArr.length > 0) {
          this.showData.splice(this.showData.length - 1, 1);

          this.showData.unshift(nextRowArr);

          this.$refs.inner.style.top = 0 - this.rowHeight + 'px';
          return true;
        } else {
          return false;
        }
      }

      // console.log("nextRowArr--:", nextRowArr);
      // } else {
      //   return false;
      // }
    },
    getFirstAnimTargetTop() {
      if (this.showData.length <= this.rowCount) {
        return 0;
      }
      return 0 - this.rowHeight;
    },
    getFirstRowDataInShowData() {
      return this.showData[parseInt(this.$refs.inner.style.top) == 0 ? 0 : 1];
    },
    appendData(d) {
      let eachKeyArr = d.map(item => item[this.eachKey]);
      if (Array.from(new Set(eachKeyArr)).length != eachKeyArr.length) {
        alert('发现重复的唯一key配置,请仔细检查');
        return false;
      }
      if (d.find(item => this.list.find(row => item[this.eachKey] == row[this.eachKey]))) {
        alert('发现重复的唯一key配置,请仔细检查');
        return;
      }
      if (d.length == 0) {
        return;
      }
      if (d.length >= this.maxListLength) {
        this.list = d;
        // this.rowScrollIndex = -1;
      } else if (d.length >= this.maxListLength - this.list.length) {
        this.list.splice(this.list.length - 1 - d.length, d.length);
        // this.rowScrollIndex -= d.length - 1;
        this.list = [].concat(d).concat(this.list);
        // this.list.unshift(d);
      } else {
        this.list = [].concat(d).concat(this.list);
        // this.list.unshift(d);
      }
      if (this.list.length >= this.maxListLength) {
        location.reload();
      }
      if (!this.showData.length) {
        let arr = [];

        // alert(Math.min(this.list.length, this.maxDataLengthInVisible));
        for (let index = 0; index < Math.min(this.list.length, this.maxDataLengthInVisible); index++) {
          let idx = Math.floor(index / this.col);
          // console.log("idx--:", idx, index);
          if (!arr[idx]) {
            arr[idx] = [];
          }
          arr[idx].unshift(this.list[this.list.length - 1 - index]);
        }
        // console.log("arr--:", arr);
        this.showData = this.showData.concat(arr.reverse());
      } else {
        void 0;
      }
      this.updateShowData();
      if (this.showData.length > 0 && this.clock == null) {
        this.animRun();
        this.clock = setInterval(this.animRun, this.scrollInterval);
      }
    }
  },
  computed: {
    maxDataLengthInVisible() {
      return (this.rowCount + 1) * this.col;
    }
  },
  watch: {
    showData: {
      immediate: true,
      handler(nv) {
        // console.log("showData nv--:", nv);
      }
    }
  },

  beforeDestroy() {
    window.clearInterval(this.clock);
  },
  props: {
    debugKey: {
      type: String,
      default: 'SCROLL'
    },
    shake: {
      type: Function,
      default: function(block, percent) {
        block.style.left = `${Math.abs(percent - 0.5) * block.offsetWidth * 2 - block.offsetWidth}px`;
      }
    },
    scrollEasing: {
      type: String,
      default: 'linear'
    },
    shakeEasing: {
      type: String,
      default: 'easeOutSine'
    },
    eachKey: {
      required: true,
      type: String
    },
    rowHeight: {
      type: Number,
      default: 30
    },
    maxListLength: {
      type: Number,
      default: 9007199254740992
    },

    col: {
      type: Number,
      default: 1
    },
    rowCount: {
      type: Number,
      default: 3
    },
    scrollDuration: {
      type: Number,
      default: 500
    },
    scrollInterval: {
      type: Number,
      default: 1000
    }
  }
};
</script>
